export default "__VITE_ASSET__DRUeLAeL__"